module.exports = __webpack_public_path__ + "img/function_content02.9287cd8c.png";